import { ContentInSectionAction, ContentEventSectionAction, ContentEventParagraphSectionAction } from '../types/ContentInSectionAction';
import { ContentInSection, statusType } from '../types/ContentInSection';

const eventFired = (keyName: any, state: any, i: any, j: any) => (dispatch: any) => {
  const success = (data: any): ContentEventSectionAction =>
    ({ type: 'Content_In_Section_Event', data });
  const failure = (error: string): ContentEventSectionAction =>
    ({ type: 'Content_In_Section_Event_Error', error });
  dispatch(success({ keyName: keyName, state: state, i: i, j: j }));
}


const paragraphEventFired = (key: any) => (dispatch: any) => {
  const success = (data: any): ContentEventParagraphSectionAction =>
    ({ type: 'Content_In_Section_Paragraph_Event', data });
  const failure = (error: string): ContentEventParagraphSectionAction =>
    ({ type: 'Content_In_Section_Paragraph_Event_Error', error });
  dispatch(success(key));
}

const setParagraphSections = (key: any) => (dispatch: any) => {
  const set = (data: any): ContentEventParagraphSectionAction =>
    ({type: 'SET_PARAGRAPH_SECTIONS', data });
  dispatch(set(key));
}

const setCreateScenario = (key: any) => (dispatch: any) => {
  const set = (data: any): ContentEventParagraphSectionAction =>
    ({type: 'SET_CREATE_SCENARIO_DATA', data });
  dispatch(set(key));
}

const setQuestion = (key: any) => (dispatch: any) => {
  const set = (data: any): ContentEventParagraphSectionAction =>
    ({type: 'SET_QUESTION_DATA', data });
  dispatch(set(key));
}

const setHints = (key: any) => (dispatch: any) => {
  const set = (data: any): ContentEventParagraphSectionAction =>
    ({type: 'SET_HINT_DATA', data });
  dispatch(set(key));
}

const setSyllabus = (key: any) => (dispatch: any) => {
  const set = (data: any): ContentEventParagraphSectionAction =>
    ({type: 'SET_SYLLABUS_DATA', data });
  dispatch(set(key));
}

const setDifficultyAndSkill = (key: any) => (dispatch: any) => {
  const set = (data: any): ContentEventParagraphSectionAction =>
    ({type: 'SET_DIFFICULTY_AND_SKILL_DATA', data });
  dispatch(set(key));
}

const paragraphActions = {
  // progressInSection,
  setCreateScenario,
  setQuestion,
  setHints,
  setSyllabus,
  setDifficultyAndSkill,
  setParagraphSections
};

export {
  eventFired,
  paragraphEventFired
}

export default paragraphActions